import { getENV } from '@libs/common-next';

/**
 * Determines the platform (sfcc or commercetools) based on order ID.
 *
 * Note: ID-based pattern matching only works reliably in PROD environment.
 * In PROD: Order IDs starting with '10' and less than 1100, or starting with '18' and less than 1900 are SFCC orders.
 * In non-PROD environments (QA, STAGE, DEV, TEST): Commerce Tools orders may have IDs in SFCC ranges,
 * so we default to 'commercetools' for all orders in these environments.
 *
 * @param id - The order ID to check
 * @returns 'sfcc' or 'commercetools' based on the order ID pattern (PROD only) or environment
 */
export const getOrderPlatform = (id: string): 'sfcc' | 'commercetools' => {
    const env = getENV('NEXT_PUBLIC_APP_ENV');

    // Only apply ID-based pattern matching in PROD
    // In other environments, Commerce Tools orders can have IDs in SFCC ranges
    if (env !== 'prod') {
        return 'commercetools';
    }

    const prefix = id.substring(0, 4);

    if (
        (prefix.startsWith('10') && parseInt(prefix, 10) < 1100) ||
        (prefix.startsWith('18') && parseInt(prefix, 10) < 1900)
    ) {
        return 'sfcc';
    } else {
        return 'commercetools';
    }
};
